













































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import NumberInput from "@/components/common/NumberInput.vue";
import {
  PublicMoneyBurden,
  CareSpecificationDetail,
  CareInvoice,
  CareSpecification,
  PatientBurden,
  PatientBurdenMoney
} from "@/components/careEdit/types";
import { PulldownItem, getInnerTax } from "@/types";

@Component({
  components: {
    NumberInput
  }
})
export default class CareInvoiceRev1 extends Vue {
  @Prop() invoice!: CareInvoice; //利用者向け請求書データ
  @Prop() specifications!: CareSpecification[]; ////介護給付費データ
  @Prop() tax_items!: PulldownItem[]; //税率選択アイテムリスト

  //利用者負担
  private get selfBurdens(): PatientBurden[] {
    let burdens: CareSpecificationDetail[] = [];
    this.specifications.forEach(specification => {
      if (specification.related_care_specification_id === 0) {
        burdens = burdens.concat(specification.specification_details);
      }
    });

    if (this.specifications.length == 1) {
      return burdens.map(burden => {
        return {
          service_code: Number(burden.service_code),
          service_name: String(burden.service_name),
          points: Number(burden.points),
          count: Number(burden.count)
        };
      });
    }

    //サービスコードごとにまとめる
    burdens.sort((x, y) => {
      return x.service_code - y.service_code;
    });

    const serviceBurdens: PatientBurden[] = [];
    let beforeDetail: PatientBurden | undefined = undefined;
    burdens.forEach(detail => {
      if (
        beforeDetail != undefined &&
        beforeDetail.service_code == detail.service_code
      ) {
        serviceBurdens[serviceBurdens.length - 1].count += Number(detail.count);
      } else {
        serviceBurdens.push({
          service_code: Number(detail.service_code),
          service_name: detail.service_name,
          points: Number(detail.points),
          count: Number(detail.count)
        });
      }
      beforeDetail = detail;
    });

    return serviceBurdens;
  }

  //利用者負担（サービス種類：利用料・超過分）
  private get patientBurdenMoneys(): PatientBurdenMoney[] {
    const burdenMoneys: PatientBurdenMoney[] = [];
    this.specifications.forEach(specification => {
      specification.specification_aggregates.forEach((aggregate, i) => {
        let isHit = false;
        const overLimitMoney = Number(aggregate.plan_points_above_money);
        let burdenMoney = 0;
        specification.public_moneys.forEach(pm => {
          if (pm.public_money_rate == 100 || pm.public_money_rate == 0) {
            burdenMoney += pm.public_money_aggregates[i].patient_burden;
          }
        });

        burdenMoneys.forEach(money => {
          if (
            money.service_type_kind_code === aggregate.service_type_kind_code
          ) {
            money.money += burdenMoney;
            money.over_money += overLimitMoney;
            isHit = true;
          }
        });
        if (!isHit) {
          burdenMoneys.push({
            service_type_kind_code: aggregate.service_type_kind_code,
            service_type: aggregate.service_type,
            money: burdenMoney,
            over_money: overLimitMoney
          });
        }
      });
    });
    return burdenMoneys;
  }

  //利用者負担合計
  private get patientBurdenTotal(): number {
    let totalMoney = 0;
    this.patientBurdenMoneys.forEach(burden => {
      totalMoney += burden.money + burden.over_money;
    });
    return totalMoney;
  }

  //全額自己負担合計
  private get allSelfBurdenTotal(): number {
    let money = 0;
    if (this.invoice !== null) {
      money +=
        Number(this.invoice.all_self_burden1_money) +
        Number(this.invoice.all_self_burden2_money) +
        Number(this.invoice.all_self_burden3_money);
    }
    return money;
  }

  //公費本人負担
  private get publicMoneyBurdens(): PublicMoneyBurden[] {
    const burdens: PublicMoneyBurden[] = [];
    this.specifications.forEach(specification => {
      specification.public_moneys.forEach(pm => {
        let isHit = false;
        let money = 0;

        pm.public_money_aggregates.forEach(aggregate => {
          money += aggregate.public_money_self_burden;
        });

        if (money > 0) {
          burdens.forEach(burden => {
            if (burden.public_money_law_number === pm.public_money_law_number) {
              isHit = true;
              burden.money += money;
            }
          });

          if (!isHit) {
            burdens.push({
              public_money_law_number: pm.public_money_law_number,
              public_money_name: pm.public_money_name,
              money: money
            });
          }
        }
      });
    });

    return burdens;
  }

  //公費本人負担合計
  private get publicMoneyBurdenTotal(): number {
    let money = 0;
    this.publicMoneyBurdens.forEach(burden => {
      money += burden.money;
    });
    return money;
  }

  //その他合計
  private get otherTotal(): number {
    let money = 0;
    if (this.invoice !== null) {
      money +=
        Number(this.invoice.other1_money) +
        Number(this.invoice.other2_money) +
        Number(this.invoice.other3_money) +
        Number(this.invoice.other4_money) +
        Number(this.invoice.other5_money);
    }
    return money;
  }

  //全て合計
  get allTotal(): number {
    return (
      this.patientBurdenTotal +
      this.allSelfBurdenTotal +
      this.publicMoneyBurdenTotal +
      this.otherTotal
    );
  }

  //消費税額（8%）
  get allTax8(): number {
    return this.getTax(8);
  }

  //消費税額（10%）
  get allTax10(): number {
    return this.getTax(10);
  }

  getTax(tax: number): number {
    let money = 0;
    if (this.invoice !== null) {
      if (this.invoice.other1_tax === tax) {
        money += getInnerTax(this.invoice.other1_money, tax);
      }
      if (this.invoice.other2_tax === tax) {
        money += getInnerTax(this.invoice.other2_money, tax);
      }
      if (this.invoice.other3_tax === tax) {
        money += getInnerTax(this.invoice.other3_money, tax);
      }
      if (this.invoice.other4_tax === tax) {
        money += getInnerTax(this.invoice.other4_money, tax);
      }
      if (this.invoice.other5_tax === tax) {
        money += getInnerTax(this.invoice.other5_money, tax);
      }
    }
    return money;
  }
}
